import { Component, AfterViewInit, EventEmitter, ElementRef, forwardRef, Input, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR, Validator, FormControl, NG_VALIDATORS } from '@angular/forms';

import { MessageService } from '../../../core/services';
import { Cep, CepService } from '../../../core/services/cep';
import { ButtonLoader } from '../../../core/utils';
import { ApiError } from 'app/core';

@Component({
    selector: 'sgt-cep',
    templateUrl: 'cep.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CepComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CepComponent), multi: true }
    ]
})
export class CepComponent implements AfterViewInit, ControlValueAccessor, Validator, OnChanges {
    element: any;

    @Input() ngModel: any;
    @Output() ngModelChange = new EventEmitter<string>();

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Output() cepEncontrado = new EventEmitter<Cep>();
    @Input() isValidate = true; // Se deve validar o CNPJ/CPF
    @Input() isApplyMask = true; // Se deve aplicar a máscara do CNPJ/CPF

    private cepInvalido = false;
    private cepNaoEncontrado = false;
    msgError: string;

    @ViewChild('inputCep') inputCep: ElementRef;
    inputCepNativeElement: any;

    propagateChange: any = () => {};

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private cepService: CepService) { }


    ngAfterViewInit() {
        this.inputCepNativeElement = this.inputCep.nativeElement;
        this.element = jQuery(this.inputCepNativeElement) as any;

        // Se for para aplicar a máscara
        if (this.isApplyMask) {
            this.applyMask();
        }
        // Se for para dar autofocus
        if (this.autofocus) {
            this.element.focus();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isValidate') {
                if (!changes[propName].isFirstChange()) {
                    this.ngControl.control.updateValueAndValidity();
                }
            }  else if (propName === 'isApplyMask') {
                if (!changes[propName].isFirstChange()) {
                    if (this.isApplyMask) {
                        this.applyMask();
                    } else {
                        this.removeMask();
                    }
                }
            }
        }
    }

    /** Aplica a máscara no elemento */
    private applyMask() {
        this.element.mask('00000-000', {placeholder: '_____-___'});
    }

    /** Remove a máscara aplicada no elemento */
    private removeMask() {
        this.element.unmask();
        this.element.removeAttr('placeholder');
    }

     /** Realiza a validação do FormControl de CEP */
    validate(c: FormControl) {
        // Se estiver configurado para não validar, então não retornamos nenhum erro
        if (!this.isValidate) {
            return null;
        }

        const isCepInvalido = this.isCepInvalido();
        if (isCepInvalido || this.cepNaoEncontrado) {
            return  {
                cepInvalido: isCepInvalido ? {cepInvalido: {valid: false}} : null,
                cepNaoEncontrado: this.cepNaoEncontrado ? {cepNaoEncontrado: {valid: false}} : null,
            };
        }

        return null;
    }

    /** Verifica se o CEP possui 8 dígitos */
    private possui8Digitos(): boolean {
        // Se o tamanho do código do CEP for menor que 8 dígitos é uma CEP inválido
        const codigoCep: string = this.inputCepNativeElement.value;
        if (codigoCep) {
            if (codigoCep.trim().length < 9) { // 8 dígitos mais o "-" (traço)
                this.msgError = 'O CEP dever conter 8 dígitos';
                return false;
            }
        }
        return true;
    }

    /** Verifica se é um CEP inválido */
    private isCepInvalido(): boolean {
        if (!this.possui8Digitos()) {
            return true;
        }
        if (this.cepInvalido) {
            return true;
        }

        return false;
    }

    /** Limpa os erros de validação do CEP */
    private clearErrors() {
        this.cepInvalido = false;
        this.cepNaoEncontrado = false;
        this.msgError = '';
    }


    /** Ao digitar no input */
    onKeyup(value) {
        this.clearErrors();
        this.ngControl.control.updateValueAndValidity();

        this.propagateChange(this.inputCepNativeElement.value);
    }

    /** Quando recebe um valor */
    writeValue(value) {
        if (value) {
            this.inputCepNativeElement.value = value;
        } else {
            this.inputCepNativeElement.value = '';
        }
    }

    /** Propaga as alterações realizadas no input */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    /** Realiza a consulta do CEP digitado */
    consultar() {
        this.inputCepNativeElement.focus();

        const codigoCep = this.inputCepNativeElement.value;
        if (!codigoCep) {
            this.messageService.info('Informe o CEP para consultá-lo', 'Informação');
            return;
        }
        if (!this.possui8Digitos()) {
            this.messageService.info('O CEP deve conter 8 dígitos para poder consultá-lo', 'Informação');
            return;
        }

        const btn = new ButtonLoader('#btnConsultaCep');
        btn.loading('');

        this.cepService.consultar(codigoCep)
        .subscribe(
            (entity: Cep) => {
                btn.reset();
                this.clearErrors();
                this.ngControl.control.updateValueAndValidity();
                this.cepEncontrado.emit(entity);
            },
            (error: ApiError) => {
                btn.reset();

                this.cepInvalido = error.status === 400;
                this.cepNaoEncontrado = error.status === 404;
                this.msgError = error.message;
                this.ngControl.control.updateValueAndValidity();
            }
        );
    }

}
